import { type Filter } from '@spendesk/bookkeeping-core-types';
import { type QueryKey } from 'react-query';

import { type SortFilter } from 'src/core/modules/bookkeep/prepare-payables/models';

import { type PayableId } from '../../models';

export const getToPreparePayableListQueryKey = (
  companyId: string,
  filtersV2?: Filter,
  textualSearch?: string,
  sort?: SortFilter,
): QueryKey => {
  return ['usePayablesQuery', companyId, filtersV2, textualSearch, sort].filter(
    Boolean,
  );
};

export const getToPreparePayableGroupsQueryKey = (
  companyId: string,
  groupBy?: string | undefined,
  filtersV2?: Filter,
  textualSearch?: string,
): QueryKey => {
  return [
    'usePayableGroupsQuery',
    companyId,
    groupBy,
    filtersV2,
    textualSearch,
  ].filter(Boolean);
};

export const getPayableQueryKey = (
  companyId: string,
  payableId: PayableId | null,
  fetcherType?: 'rest' | 'graphQL',
  subResource?: 'proofs' | 'fraud-status',
): QueryKey => {
  return [
    'useGetPayableQuery',
    companyId,
    payableId,
    fetcherType,
    subResource,
  ].filter(Boolean);
};

export const getPayableProofsQueryKey = (
  companyId: string,
  payableId: PayableId | null,
): QueryKey => {
  return getPayableQueryKey(companyId, payableId, undefined, 'proofs');
};

export const getPayableFraudStatusQueryKey = (
  companyId: string,
  payableId: PayableId | null,
): QueryKey => {
  return getPayableQueryKey(companyId, payableId, undefined, 'fraud-status');
};

export const getPayableCountQueryKey = (
  companyId: string,
  search?: string,
  filtersV2?: Filter,
): QueryKey => {
  return ['useGetPayableCount', companyId, search, filtersV2].filter(Boolean);
};

export const getPayableListQueryKey = (
  companyId: string,
  filter?: {
    search: string | undefined;
  },
  filtersV2?: Filter,
): QueryKey => {
  return ['useGetPayableList', companyId, filter, filtersV2].filter(Boolean);
};

export const getPayableFieldValuesQueryKey = (companyId: string): QueryKey => {
  return ['useFieldValuesQuery', companyId];
};

export const getPayableFilterQueryKey = (companyId: string): QueryKey => {
  return ['usePayableFilter', companyId];
};
